import { useEffect } from "react";
import { loadCSS } from "fg-loadcss";

function ComplexGrid(props) {
  const fontFunc = () => {
    const node = loadCSS(
      "https://use.fontawesome.com/releases/v5.12.0/css/all.css",
      document.querySelector("#font-awesome-css")
    );

    return () => {
      node.parentNode.removeChild(node);
    };
  };
  useEffect(() => {
    fontFunc();
  }, [props.data.icon, props.data.color]);

  return (
    <div className="card-icon">
      <div className="icon">
        <i className={`fa fa-${props.data.icon}`} style={{ fontSize: 100 }}></i>
      </div>
      <h2 className="card-title">{props.data.title}</h2>
      <div className="card-body">{props.data.description}</div>
    </div>
  );
}

const logoWithTitle = {
  Renderer: (props) => <ComplexGrid {...props} />,
  id: "logoWithTitle",
  version: "logoWithTitle",
  title: "Logo with Title",
};

export default logoWithTitle;
